import cx from "clsx";
import { Collection } from "kreate-common/modules/business-types";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import Link from "next/link";
import React from "react";

import styles from "./index.module.scss";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  collection: Collection | undefined | null;
};

export default function TabAbout({ className, style, collection }: Props) {
  return (
    <div className={cx(className, styles.container)} style={style}>
      <Flex.Col gap="24px">
        <div className={styles.title}>{"Tags"}</div>
        <Flex.Row
          gap="4px 12px"
          flexWrap="wrap"
          className={styles.tagsContainer}
        >
          {collection?.tags?.map((tag, index) => (
            <Link
              href={{
                pathname: "/explore/collections",
                query: { q: "#" + tag },
              }}
              key={index}
              title={"#" + tag}
              className={styles.tag}
            >
              {"#" + tag}
            </Link>
          ))}
        </Flex.Row>
      </Flex.Col>
    </div>
  );
}
